import { Button } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BillType } from '../../../bills/enums/billType'
import { PayableSubjectType } from '../../../paymentReconciliationModal/types/payableSubjectType'

type MultipleSubjectsButtonProps = {
  onClick: () => void
  payableSubjectType?: PayableSubjectType
}

export const MultipleSubjectsButton = ({ onClick, payableSubjectType }: MultipleSubjectsButtonProps): ReactElement => {
  const { t } = useTranslation()
  const translation =
    payableSubjectType === BillType.Bill
      ? t('bill.payment_reconcile.button.register_multiple_bills')
      : t('bill.payment_reconcile.button.register_multiple_invoices')

  return (
    <Button onClick={onClick} variant="text" icon="layers">
      {translation}
    </Button>
  )
}
